<template>
    <div>
      <div v-if="!separateSearchEngineTitleAndTitle" style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not configured
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewSearchPageTitle',
    props: [
      'separateSearchEngineTitleAndTitle',
      'useMyCurrentTitle',
    ],
}
</script>

<style lang="scss" scoped>

</style>